import type { FC } from "react";
import { durationBetweenTimestamps, timeAgo } from "@/format/time";
import { Timestamp, type PlainMessage } from "@bufbuild/protobuf";
import { Text } from "@/components/podkit/typography/Text";
import { WorkflowExecutionActionStepStatusIcon } from "@/components/automations/AutomationExecutionActionStepStatusIcon";
import { Card } from "@/components/flexkit/Card";
import type { WorkflowExecutionAction_Status_StepStatus } from "gitpod-next-api/gitpod/v1/workflow_pb";
import IconCalendar2 from "central-icons/IconCalendar2";
import IconStopwatch from "central-icons/IconStopwatch";

export const WorkflowExecutionActionStepCard: FC<{
    step: PlainMessage<WorkflowExecutionAction_Status_StepStatus>;
}> = ({ step }) => {
    const duration =
        step.startedAt && step.finishedAt ? durationBetweenTimestamps(step.startedAt, step.finishedAt) : undefined;

    return (
        <Card variant={"bordered"} className="border bg-surface-secondary shadow-none">
            <div className="flex items-center gap-4">
                <div className="flex items-center gap-1">
                    <WorkflowExecutionActionStepStatusIcon step={step} />
                    <Text className="text-sm text-content-muted">Step {step.stepIndex + 1}</Text>
                </div>
                <div className="flex items-center gap-1">
                    <IconCalendar2 size={16} className="text-content-muted" />
                    <Text className="text-sm text-content-muted">
                        {step.startedAt ? <span>{timeAgo(new Timestamp(step.startedAt).toDate())}</span> : "-"}
                    </Text>
                </div>
                <div className="flex items-center gap-1">
                    <IconStopwatch size={16} className="text-content-muted" />
                    <Text className="text-sm text-content-muted">
                        {duration ? <span>{duration}</span> : <span>{step.startedAt ? "In progress" : "Pending"}</span>}
                    </Text>
                </div>
                {step.failureMessage && (
                    <Text className="grow text-right text-sm text-content-destructive">{step.failureMessage}</Text>
                )}
            </div>
        </Card>
    );
};
